import { Animated } from "@commonlibs";
import clsx from "clsx";
import CardNavigation from "ui/common/components/layout/CardNavigation/CardNavigation";
import { CardNavigationProps } from "ui/common/components/layout/CardNavigation/CardNavigation.types";

function AuthNavigationCard({ className, divider = true, header, children, ...rest }: CardNavigationProps) {
    return (
        <Animated.Slide in direction="up" duration={{ enter: 650, exit: 300 }}>
            <CardNavigation
                className={clsx("auth-navigation-card", className)}
                header={{ right: "support", rightColor: "primary", leftColor: "primary", ...header }}
                divider={divider}
                {...rest}
            >
                {children}
            </CardNavigation>
        </Animated.Slide>
    );
}

export default AuthNavigationCard;
